// src/components/AuthGate.jsx
import React from "react";
import { supabase } from "../lib/supabaseClient";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthButton from "./AuthButton.jsx";

export default function AuthGate({ children }) {
  const loc = useLocation();

  const qp = new URLSearchParams(loc.search);
  const allowGuestArtistFlash =
    qp.get("guest") === "1" && qp.get("from") === "artist-flash";

  // Dev bypass — matches ProtectedRoute. DEV-only so it can never
  // accidentally turn off auth in a production build.
  const devBypass =
    import.meta.env.DEV &&
    (import.meta.env.VITE_AUTH_BYPASS === "1" ||
      (typeof localStorage !== "undefined" &&
        localStorage.getItem("tt_dev_bypass") === "1"));
  if (devBypass || allowGuestArtistFlash) return children;

  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);

  useEffect(() => {
    let mounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setSession(data.session ?? null);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
      setLoading(false);
    });

    return () => {
      mounted = false;
      subscription?.unsubscribe();
    };
  }, []);

  if (loading) return null;

  if (!session) {
    return (
      <div
        style={{
          display: "grid",
          placeItems: "center",
          minHeight: "100dvh",
          padding: 24,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1 style={{ marginBottom: 12 }}>Sign in to continue</h1>
          <AuthButton />
        </div>
      </div>
    );
  }

  return children;
}